import { render, staticRenderFns } from "./MutasiBank.vue?vue&type=template&id=b8167f00&"
import script from "./MutasiBank.vue?vue&type=script&lang=js&"
export * from "./MutasiBank.vue?vue&type=script&lang=js&"
import style0 from "./MutasiBank.vue?vue&type=style&index=0&id=b8167f00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports